if (window.innerWidth > 768) {
  document.addEventListener('DOMContentLoaded', () => {
    const btn = document.querySelector('.btn_khampha');
    const cloudsLeft = document.querySelectorAll('.cloud-left');
    const cloudsRight = document.querySelectorAll('.cloud-right');
    const intro = document.querySelector('.intro');
    const contentMain = document.querySelector('.contentMain');
    const floating = document.querySelector('.floating');
  
    const hasPlayed = localStorage.getItem('introPlayed') === 'true';
    const hash = window.location.hash;
    const isHeaderHash = hash === '#tqht_mansite_header';
    const hasOtherHash = hash && hash !== '#tqht_mansite_header';
  
    // Kiểm tra nếu các phần tử tồn tại trước khi thao tác
    if (intro && contentMain && floating) {
      if (hasOtherHash || (isHeaderHash && hasPlayed)) {
        // ✅ Nếu là hash khác hoặc đã xem header intro -> ẩn intro
        intro.style.display = 'none';
        contentMain.classList.add('active');
        floating.classList.add('active');
  
        if (isHeaderHash && !hasPlayed) {
          localStorage.setItem('introPlayed', 'true');
        }
  
      } else {
        // ✅ Hiện intro nếu là lần đầu vào header hoặc không có hash
        intro.style.display = 'block';
    
        // Hiệu ứng sáng dần từ brightness(0.2) đến brightness(1) trong 5 giây
        let brightnessValue = 0.2; // Bắt đầu từ 0.2
        const interval = 50; // khoảng thời gian thay đổi mỗi lần (ms)
        const step = (1 - 0.2) / (5000 / interval); // mỗi lần thay đổi giá trị brightness trong 5 giây
    
        // Hàm thay đổi độ sáng
        const intervalId = setInterval(() => {
          brightnessValue += step;
          intro.style.filter = `brightness(${brightnessValue})`;
    
          if (brightnessValue >= 1) {
            clearInterval(intervalId); // Dừng lại khi đạt giá trị 1
          }
        }, interval);
    
        contentMain.classList.remove('active');
        floating.classList.remove('active');
  
        btn.addEventListener('click', () => {
          cloudsLeft.forEach(cloud => cloud.classList.add('animate-left'));
          cloudsRight.forEach(cloud => cloud.classList.add('animate-right'));
  
          intro.classList.add('hidden');
  
          setTimeout(() => {
            contentMain.classList.add('active');
            floating.classList.add('active');
            localStorage.setItem('introPlayed', 'true');
          }, 2000);
  
          setTimeout(() => {
            cloudsLeft.forEach(cloud => cloud.classList.remove('animate-left'));
            cloudsRight.forEach(cloud => cloud.classList.remove('animate-right'));
          }, 3000);
        });
      }
    }
  });
  
}
